<h1 style="text-align: center;" mat-dialog-title>{{data?.title}}</h1>
<div mat-dialog-content>
  <p>{{data?.message}}</p>
</div>
<div mat-dialog-actions *ngIf="data.prompt" fxLayout="row" fxLayoutAlign="space-between center" >
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</div>
